// extracted by mini-css-extract-plugin
export default {"productLoaders":"InstagramLoader_productLoaders__w0K16","spinnerLoaders":"InstagramLoader_spinnerLoaders__6NM89"};